import { networkActionsCreator } from '../../../../admincore'

const actions = {
  ...networkActionsCreator('dispatch'),
}

const create = (id, params) => {
  return {
    type: actions.LOAD,
    payload: {
      id,
      params,
    },
  }
}

const reset = () => {
  return {
    type: actions.RESET,
  }
}

export { actions, create, reset }
